import type { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useMomentFormSurveys } from "../../../../survey/hooks/use-moment-form-surveys";
import type { EditorLinkData } from "../../plugins/toolbar/hooks/use-link-button-on-click";
import { SurveySelectorDropdown } from "../survey/survey-selector-dropdown";
import { getSurveyIdFromUrl } from "../utils/survey-url";
import type { Link } from "./types";

export const LinkSurveyField: FC<{
  data: EditorLinkData;
}> = ({ data: { type, url } }) => {
  const survey_id = getSurveyIdFromUrl(url);
  const surveyLoader = useMomentFormSurveys({ allowedStatuses: ["active"] });
  const { control } = useFormContext<Link>();

  if (type !== "survey_link") return null;

  return (
    <Controller
      name="url"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <SurveySelectorDropdown
          channel={false}
          onChange={field.onChange}
          error={error}
          surveyLoader={surveyLoader}
          id={survey_id || undefined}
        />
      )}
    />
  );
};
